import { api, ApiError } from "@/api/api";
import { useQuery } from "@tanstack/react-query";

export function useEpisodeTextsByEpisodeId(episodeId: string | undefined) {
  return useQuery<{ pages: { pageNumber: number; text: string }[] }, ApiError>({
    queryKey: ["GET", "episodeDetails", episodeId, "texts"],
    queryFn: () => api.episodes.episodeId.texts.get({ episodeId: episodeId! }),
    enabled: !!episodeId,
  });
}
